import { Link } from 'react-router-dom';
import { getChannel } from '@/mocks/channels';
import { getArticlesByChannel } from '@/mocks/articles';
import { ArticleCard } from '@/components/feature/ArticleCard';
import { toneClasses } from '@/components/feature/ChannelPill';

export default function FocusSection({ slug }: { slug: string }) {
  const channel = getChannel(slug);
  const list = getArticlesByChannel(slug);
  if (!channel || list.length === 0) return null;
  const lead = list[0];
  const rest = list.slice(1);

  return (
    <section className="mx-auto max-w-6xl px-4 md:px-6">
      <div className="mb-5 flex items-end justify-between border-b border-background-200/70 pb-3">
        <div>
          <div className="flex items-center gap-2">
            <span
              className={`inline-flex h-7 items-center gap-1 rounded-full border px-3 text-xs font-bold ${toneClasses(
                channel.accent,
              )}`}
            >
              <i className="ri-fire-line" aria-hidden="true" /> {channel.name}
            </span>
            <h2 className="flex items-center text-lg font-bold text-foreground-950 md:text-xl">
              {channel.tagline}
            </h2>
          </div>
          <p className="mt-1.5 text-xs text-foreground-400">{channel.desc}</p>
        </div>
        <Link
          to={`/channel/${slug}`}
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex"
        >
          进入栏目 <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      </div>

      <div className="grid gap-5 lg:grid-cols-5">
        {/* lead */}
        <Link
          to={`/news/${lead.id}`}
          className="group relative block overflow-hidden rounded-lg lg:col-span-3"
        >
          <div className="relative aspect-[4/3] w-full overflow-hidden md:aspect-[16/10]">
            <img
              src={lead.cover}
              alt={lead.title}
              title={`${lead.title}-热瓜速递`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
          </div>
          <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
            <span className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-semibold ${toneClasses(channel.accent)}`}>
              <i className="ri-flashlight-fill" aria-hidden="true" /> 栏目头条
            </span>
            <h3 className="mt-2.5 line-clamp-2 text-lg font-bold leading-snug text-background-50 md:text-xl">
              {lead.title}
            </h3>
            <p className="mt-2 hidden text-sm leading-relaxed text-background-100/85 sm:line-clamp-2">
              {lead.summary}
            </p>
            <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-medium text-background-50">
              立即阅读 <i className="ri-arrow-right-line" aria-hidden="true" />
            </span>
          </div>
        </Link>

        {/* rest + cta */}
        <div className="flex flex-col gap-3 lg:col-span-2">
          {rest.map((a) => (
            <ArticleCard key={a.id} article={a} mode="row" />
          ))}
          <Link
            to={`/channel/${slug}`}
            className={`mt-auto inline-flex items-center justify-center gap-1 rounded-lg border border-dashed px-4 py-3 text-sm font-semibold transition-colors hover:brightness-95 ${toneClasses(
              channel.accent,
            )}`}
          >
            <i className="ri-add-line" aria-hidden="true" /> 查看{channel.name}全部 {list.length} 篇
          </Link>
        </div>
      </div>
    </section>
  );
}